import { render } from "./logPratiche.vue?vue&type=template&id=0b2dedb8&scoped=true"
import script from "./logPratiche.vue?vue&type=script&lang=js"
export * from "./logPratiche.vue?vue&type=script&lang=js"

import "./logPratiche.vue?vue&type=style&index=0&id=0b2dedb8&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2dedb8"]])

export default __exports__